function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Scrollbars } from 'react-custom-scrollbars';
import { SortableContainer, SortableElement } from 'react-sortable-hoc';
import MultiSelectItem from "./MultiSelectListItem";
var SortableItem = SortableElement(function (_ref) {
  var itemIndex = _ref.itemIndex,
      item = _ref.item,
      rowRenderer = _ref.rowRenderer;
  return React.createElement("div", null, rowRenderer({
    item: item,
    index: itemIndex
  }));
});
var SortableList = SortableContainer(function (_ref2) {
  var items = _ref2.items,
      rowRenderer = _ref2.rowRenderer;
  return React.createElement("div", null, items.map(function (item, index) {
    return React.createElement(SortableItem, {
      key: index,
      index: index,
      item: item,
      itemIndex: index,
      rowRenderer: rowRenderer
    });
  }));
});

var MultiSelectList =
/*#__PURE__*/
function (_Component) {
  _inherits(MultiSelectList, _Component);

  function MultiSelectList() {
    var _ref3;

    var _temp, _this;

    _classCallCheck(this, MultiSelectList);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(_this, (_temp = _this = _possibleConstructorReturn(this, (_ref3 = MultiSelectList.__proto__ || Object.getPrototypeOf(MultiSelectList)).call.apply(_ref3, [this].concat(args))), Object.defineProperty(_assertThisInitialized(_this), "selectAllItemRenderer", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props = _this.props,
            data = _this$props.data,
            onToggleItem = _this$props.onToggleItem;
        var AllItem = {
          name: 'ALL',
          label: 'ALL',
          checked: !!data.length && data.every(function (item) {
            return item.checked;
          })
        };
        return React.createElement(MultiSelectItem, {
          key: "ALL",
          item: AllItem,
          index: "ALL",
          onToggleItem: onToggleItem
        });
      }
    }), Object.defineProperty(_assertThisInitialized(_this), "listRenderer", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value(list) {
        return list.map(function (item, index) {
          return _this.rowRenderer({
            item: item,
            index: index
          });
        });
      }
    }), Object.defineProperty(_assertThisInitialized(_this), "rowRenderer", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value(_ref4) {
        var item = _ref4.item,
            index = _ref4.index;
        return React.createElement(MultiSelectItem, {
          key: index,
          item: item,
          index: index,
          isSortable: _this.props.isSortable,
          onToggleItem: _this.props.onToggleItem
        });
      }
    }), _temp));
  }

  _createClass(MultiSelectList, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          data = _props.data,
          onSortEnd = _props.onSortEnd,
          isSortable = _props.isSortable,
          selectAllEnabled = _props.selectAllEnabled,
          _props$maxContentHeig = _props.maxContentHeight,
          maxContentHeight = _props$maxContentHeig === void 0 ? '250px' : _props$maxContentHeig,
          _props$minContentHeig = _props.minContentHeight,
          minContentHeight = _props$minContentHeig === void 0 ? '50px' : _props$minContentHeig;

      if (!data.length) {
        return React.createElement("div", {
          className: "nx-table__multiselect-container"
        }, React.createElement("div", {
          className: "nx-table__multiselect-no-results"
        }, "No filters applied."));
      }

      return React.createElement(Scrollbars, {
        autoHeight: true,
        autoHeightMin: minContentHeight,
        autoHeightMax: maxContentHeight
      }, React.createElement("div", {
        className: "nx-table__multiselect-container"
      }, selectAllEnabled && this.selectAllItemRenderer(), !!isSortable ? React.createElement(SortableList, {
        items: data,
        onSortEnd: onSortEnd,
        pressDelay: 150,
        rowRenderer: this.rowRenderer,
        helperClass: "nx-table__multiselect-item--dragging",
        transitionDuration: 500
      }) : this.listRenderer(data)));
    }
  }]);

  return MultiSelectList;
}(Component);

Object.defineProperty(MultiSelectList, "propTypes", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: {
    data: PropTypes.array.isRequired,
    onToggleItem: PropTypes.func.isRequired
  }
});
Object.defineProperty(MultiSelectList, "defaultProps", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: {
    data: [],
    onToggleItem: function onToggleItem() {}
  }
});
export default MultiSelectList;